import React, { useState, useEffect } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import SVG from "react-inlinesvg";
import { ToggleButtonWithYesNo } from "../../../AllButton/ToggleButtonReuse";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Scrollbars from "react-custom-scrollbars";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  add_category_menu_setup,
  edit_category_menu_setup,
} from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction";
import { update_ordering_subscription_taxes } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";

const FastFoodAddCategories = (props) => {
  const { transcript } = useSpeechRecognition();
  //const [file, setFile] = useState(null);
  const [WithTaxes, setWithTaxes] = useState(true);
  const [active, setActive] = useState("PERCENTAGE");
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [keywords, setKeywords] = useState([]);
  const [keywordsText, setKeywordsText] = useState("");
  // const uploadImage = (e) => {
  //   setFile(URL.createObjectURL(e.target.files[0]));
  // };
  const handleWithTaxes = () => {
    setWithTaxes(!WithTaxes);
  };
  const handleTextPORV = (e) => {
    setActive(e);
    formikCustom.setFieldValue("flag", e);
  };
  const handleNextStep = (e) => {
    setStep(e);
  };
  /*******************************
   * Add Keywords Action
   ******************************/
  const addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsTextVr = keywordsText;
    let keywordsArr = keywords;
    if (keywordsTextVr === "") {
      errors.keywordsTextVr = "Keywords is Required";
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert("Keywords Already Exits");
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      setKeywordsText("");
    }
  };

  /*************************************
   * @DESC Keywords Change Handlers
   ************************************/
  const onKeywordsChangeHandler = (e) => {
    setKeywordsText(e.target.value);
  };
  /*************************************
   * @DESC Remove Keywords Change Handlers
   ************************************/
  const removeKeywordsAction = (indexId) => (e) => {
    var data = [...keywords];
    data.splice(indexId, 1);
    setKeywords(data);
  };

  const [categoryClassification, setClassification] = useState([
    { id: 1, name: "Soups" },
    { id: 2, name: "Starters" },
    { id: 3, name: "Appetizers" },
    { id: 4, name: "Entree / Main" },
    { id: 5, name: "Hot Beverages" },
    { id: 6, name: "Alcohol" },
    { id: 7, name: "Other" },
  ]);

  const [productClassification, setProductClassification] = useState([
    { id: 1, name: "Food/Type" },
    { id: 2, name: "Ready/Packet" },
  ]);

  const definedTaxes = ["Taxability", "Packaging Charges", "Surcharges"];
  const [taxInfo, setTaxInfo] = useState([
    {
      tax_name: "Taxability",
      status: false,
      value: "",
      flag: "PERCENTAGE",
      description: "(Taxes are same for all the items in the category)",
    },
    {
      tax_name: "Packaging Charges",
      status: false,
      value: "",
      flag: "VALUE",
      description: "(Taxes are same for all the items in the category)",
    },
    {
      tax_name: "Surcharges",
      status: false,
      value: "",
      flag: "PERCENTAGE",
      description: "(Taxes are same for all the items in the category)",
    },
  ]);

  const handleChecked = (status, index) => {
    var updateStatus = taxInfo.map((item, i) => {
      if (index === i) {
        return { ...item, status: !status };
      } else {
        return { ...item };
      }
    });
    setTaxInfo(updateStatus);
  };

  const handleTypeChange = (valueType, index) => {
    var updateStatus = taxInfo.map((item, i) => {
      if (index === i) {
        if (valueType === "PERCENTAGE") {
          valueType = "VALUE";
        } else {
          valueType = "PERCENTAGE";
        }
        return { ...item, flag: valueType };
      } else {
        return { ...item };
      }
    });
    setTaxInfo(updateStatus);
  };

  const handleUpdateValue = (e, index) => {
    const updateValue = [...taxInfo];
    updateValue[index].value = e.target.value;
    setTaxInfo(updateValue);
    formikStepTwo.setFieldValue("test", "");
  };

  const [customSurcharge, setCustomSurcharge] = useState([]);
  const addCustomSurcharge = (e) => {
    e.preventDefault();
    setCustomSurcharge([{ key: "value" }]);
  };
  const deleteCustomSurcharge = () => {
    setCustomSurcharge([]);
  };

  const formikCustom = useFormik({
    initialValues: {
      tax_name: "",
      value: "",
      status: true,
      flag: "VALUE",
      description: "",
    },
    validationSchema: yup.object({
      tax_name: yup
        .string()
        .max(128, "Must be 128 characters or less")
        .required("Surcharge name  is required"),
      value: yup.number().required("This field is required"),
    }),
    onSubmit: (values) => {
      setTaxInfo([...taxInfo, values]);
      formikCustom.resetForm();
      deleteCustomSurcharge();
      // handleNextStep(2);
    },
  });
  const [count, setCount] = useState(1);

  const onClickNext = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let catNameElement = document.getElementById("name");
      catNameElement.focus();
    } else if (formik.errors && formik.errors.category_classification) {
      let categoryClassficationElement = document.getElementById(
        "category_classification"
      );
      categoryClassficationElement.focus();
    } else if (formik.errors && formik.errors.product_classification) {
      let productClassficationElement = document.getElementById(
        "product_classification"
      );
      productClassficationElement.focus();
    }
  }, [count]);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      category_classification: "",
      product_classification: "",
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(128, "Must be 128 characters or less")
        .required("Category name is required"),
      category_classification: yup
        .string()
        .required("Please select category classification"),
      product_classification: yup
        .string()
        .required("Please select product classification"),
    }),
    onSubmit: (values) => {
      formik.setFieldValue("keywords", keywords);
      handleNextStep(2);
    },
  });

  const validate = () => {
    const errors = [];
    if (!WithTaxes) {
      for (var i = 0; i < taxInfo.length; i++) {
        if (taxInfo[i].status) {
          if (taxInfo[i].value.length === 0) {
            errors[i] = { value: "This field is required" };
          }
        }
      }
    }

    return errors;
  };

  const onEditSuccess = (catId, data) => {
    let totlaChange = data?.price_include_tax
      ? data.charges
      : props.orderingTaxesData?.tax_values;
    let take_away_charges = [];
    let curb_side_charges = [];
    let dine_in_charges = [];
    let skip_line_charges = [];
    let catering_banquet_charges = [];
    let home_delivery_charges = [];
    /*******************
     * @DESC Take Away
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].take_away !== undefined &&
        totlaChange[i].take_away !== null
      ) {
        take_away_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].take_away,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Curb Side
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].curb_side !== undefined &&
        totlaChange[i].curb_side !== null
      ) {
        curb_side_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].curb_side,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }

    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].skip_line !== undefined &&
        totlaChange[i].skip_line !== null
      ) {
        skip_line_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].skip_line,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Dine In
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].dine_in_order !== undefined &&
        totlaChange[i].dine_in_order !== null
      ) {
        dine_in_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].dine_in_order,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Catering Banquet
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].catering_banquet !== undefined &&
        totlaChange[i].catering_banquet !== null
      ) {
        catering_banquet_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].catering_banquet,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Home Delivery
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].home_delivery !== undefined &&
        totlaChange[i].home_delivery !== null
      ) {
        home_delivery_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].home_delivery,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    const token = props.auth.user.accessToken;
    let formData = {
      category: {
        charges: totlaChange,
      },
      Items: {
        take_away: {
          sur_charges: take_away_charges,
        },
        curb_side: {
          sur_charges: curb_side_charges,
        },
        skip_line: {
          sur_charges: skip_line_charges,
        },
        dine_in_order: {
          sur_charges: dine_in_charges,
        },
        catering_banquet: {
          sur_charges: catering_banquet_charges,
        },
        home_delivery: {
          sur_charges: home_delivery_charges,
        },
      },
    };
    props.update_ordering_subscription_taxes(
      formData,
      token,
      true,
      catId,
      onSuccess(),
      (err) => onErrorTaxes(err)
    );
  };

  const onErrorTaxes = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onSuccess = () => {
    props.history.push(
      props.history.location.pathname.includes("admin")
        ? "/admin-fastfood/menusetup"
        : "/fastfood/menusetup"
    );
  };

  const formikStepTwo = useFormik({
    initialValues: {
      test: "",
    },
    validate,
    onSubmit: (values) => {
      var charges = [];
      if (!WithTaxes) {
        for (let i = 0; i < taxInfo.length; i++) {
          if (taxInfo[i].status) {
            charges.push(taxInfo[i]);
          }
        }
      }
      if (!WithTaxes && charges.length === 0) {
        Alert.error(`<h4> Please add taxes</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        let formData = {};
        formData = { ...formik.values };
        if (WithTaxes) {
          formData.price_include_tax = true;
          formData.cross_selling = {};
          formData.charges = [];
        } else {
          formData.price_include_tax = false;
          formData.cross_selling = {};
          formData.charges = charges;
        }
        const token = props.auth.user.accessToken;
        if (
          props &&
          props.activeCategoryData &&
          props.activeCategoryData._id &&
          props.activeCategoryData._id.length > 2
        ) {
          props.edit_category_menu_setup(
            props.activeCategoryData._id,
            formData,
            token,
            (catId) => onEditSuccess(catId, formData)
          );
        } else {
          props.add_category_menu_setup(formData, token, onSuccess);
        }
      }

      // handleNextStep(2);
    },
  });

  const onClickSave = () => {
    formikStepTwo.handleSubmit();
  };

  useEffect(() => {
    if (
      props &&
      props.activeCategoryData &&
      props.activeCategoryData._id &&
      props.activeCategoryData._id.length > 2
    ) {
      let data = props.activeCategoryData;
      formik.setFieldValue("name", data.name);

      if (data.keywords) {
        setKeywords(data.keywords);
      }

      formik.setFieldValue("description", data.description);
      formik.setFieldValue(
        "category_classification",
        data.category_classification
      );
      formik.setFieldValue(
        "product_classification",
        data.product_classification
      );
      if (data.charges.length >= 1) {
        setWithTaxes(false);
        //let tempTaxInfo = [];
        let charges = data.charges;
        // for (let i = 0; i < charges.length; i++) {
        //   if (definedTaxes.includes(charges[i].tax_name)) {
        //   } else {
        //     tempTaxInfo.push(charges[i]);
        //   }
        // }
        setTaxInfo(charges);
      }
    }
  }, []);

  return (
    <>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
              >
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={
                      props.history.location.pathname.includes("admin")
                        ? "/admin-fastfood/menusetup"
                        : "/fastfood/menusetup"
                    }
                  />
                </div>
                <div className="onboarding_process_screen-button-map">
                  <div className="mb-4">
                    <TopTextReusableComponent
                      headingText={
                        props &&
                        props.activeCategoryData &&
                        props.activeCategoryData._id &&
                        props.activeCategoryData._id.length > 2
                          ? "Edit Category"
                          : "New Category"
                      }
                      headingParagraph="Manage your food items"
                    />
                  </div>
                  <Form>
                    {step === 1 && (
                      <React.Fragment>
                        <div className="nav-scroller mb-4">
                          <ul
                            className="enStepNav nav list-unstyled d-flex justify-content-between"
                            style={{ width: 300 }}
                          >
                            <li className="doing">
                              <div className="stepNumber">01</div>
                              <div className="text">Define Category</div>
                            </li>
                            <li className="todo">
                              <div className="stepNumber">02</div>
                              <div className="text">Taxes & Other Details</div>
                            </li>
                          </ul>
                        </div>
                        <Form.Label className="f14-500 mb-3">
                          Add Menu Category
                        </Form.Label>
                        <Row>
                          <Col md={8}>
                            <NewInputText
                              controlClass={"name"}
                              labelText="Category Name"
                              extraClass={`mb-1 w-100 ${
                                formik.errors.name && formik.touched.name
                                  ? "enError"
                                  : ""
                              }`}
                              name="name"
                              onChange={formik.handleChange}
                              value={formik.values.name}
                              onFocusOut={formik.handleBlur}
                            />
                            {formik.errors.name && formik.touched.name ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.name}
                              </div>
                            ) : null}
                          </Col>
                          <Col md={8} className="mt-3">
                            <div className=" onboarding-restaurant-details-margin">
                              <div className="row align-items-center">
                                <div className="col-7">
                                  <NewInputText
                                    extraClass="mb-0"
                                    name="keywordsText"
                                    onChange={onKeywordsChangeHandler}
                                    value={keywordsText}
                                    labelText="Keywords"
                                  />
                                  <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                                    {errors.keywordsText}
                                  </div>
                                </div>
                                <div className="col-5">
                                  <AddButtonIconComponent
                                    buttonText="Add More Keywords"
                                    onClick={addKeywordsAction}
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md={8} className="mt-3">
                            <div className="col-12 p-0 onboarding-restaurant-details-margin">
                              <div className="enChipBox">
                                <Scrollbars
                                  style={{ width: "100%", height: 135 }}
                                >
                                  {keywords &&
                                    keywords.map((data, index) => {
                                      return (
                                        <div className="mb-3 mr-3" key={index}>
                                          <div className="keywords_button">
                                            <p>{data}</p>
                                            <span
                                              className="ml-2"
                                              onClick={removeKeywordsAction(
                                                index
                                              )}
                                            >
                                              <SVG
                                                src={require("../../../../../../../assets/images/UserManagement/close.svg")}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </Scrollbars>
                              </div>
                              <div className="opacity5 f10-400">
                                * Manage the utterances for the Categories
                                <p>
                                  {transcript
                                    ? transcript
                                    : "Start listening for transcript"}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col md={4} className="mt-3">
                            <Button
                              variant="danger"
                              onClick={SpeechRecognition.startListening}
                            >
                              <SVG
                                src={require("../../../../../../../assets/images/UserManagement/microphone.svg")}
                                width="22px"
                                height="30px"
                              />
                            </Button>
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col md={8}>
                            <NewInputText
                              labelText="Category Description *"
                              extraClass="mb-3 w-100"
                              multiline={true}
                              rows="4"
                              name="description"
                              onChange={formik.handleChange}
                              value={formik.values.description}
                            />
                          </Col>
                        </Row>
                        {/* <Form.Label className="f14-500 mb-1">Add Photos</Form.Label>
                    <div className="d-flex flex-wrap">
                      <div className="enUploadBox">
                        <Image
                          src={require("../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          onChange={uploadImage}
                        />
                      </div>
                      {file && (
                        <div className="enIconUploaded">
                          <button
                            type="button"
                            className="enCloseButton"
                            onClick={() => setFile(null)}
                          >
                            <Image
                              src={require("../../../../../../../assets/images/UserManagement/en_close.svg")}
                              alt="uploadImg"
                              title="uploadImg"
                              fluid
                            />
                          </button>
                          <Image
                            src={file}
                            alt="icon"
                            title="icon"
                            className=""
                            fluid
                          />
                        </div>
                      )}
                    </div> */}
                        <hr />
                        <Form.Label className="f14-500 mb-3">
                          Category Classification
                        </Form.Label>
                        <div className="d-flex align-items-center">
                          {/* <div className="position-relative">
                        <div
                          className={
                            "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                          }
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                              }
                              alt="icon"
                              title="Soups"
                            />

                            <span className="para-data-icon">Soups</span>
                          </div>
                        </div>
                      </div>
                      <div className="position-relative">
                        <div
                          className={
                            "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                          }
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                              }
                              alt="icon"
                              title="Starters"
                            />

                            <span className="para-data-icon">Starters</span>
                          </div>
                        </div>
                      </div> */}
                          <div className="mb-1 d-flex flex-wrap">
                            {categoryClassification.map((item, index) => (
                              <div
                                className="enCheckWithText small"
                                key={index}
                              >
                                <input
                                  id="category_classification"
                                  type="radio"
                                  name="category_classification"
                                  value={item.name}
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.category_classification ===
                                    item.name
                                  }
                                />
                                <label className="w-100 d-flex align-items-center justify-content-center">
                                  {item.name}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                        {formik.errors.category_classification &&
                        formik.touched.category_classification ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.category_classification}
                          </div>
                        ) : null}
                        <Form.Label className="f14-500 my-3">
                          Product Classification
                        </Form.Label>
                        <Row>
                          {productClassification.map((item, index) => (
                            <Col md={3} key={index}>
                              <label className="enRadioWithText small f12-400 w-100 mb-3">
                                {item.name}
                                <input
                                  id="product_classification"
                                  type="radio"
                                  name="product_classification"
                                  value={item.name}
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.product_classification ===
                                    item.name
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </Col>
                          ))}
                        </Row>
                        {formik.errors.product_classification &&
                        formik.touched.product_classification ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.product_classification}
                          </div>
                        ) : null}
                        <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                          <div>
                            <ReusableOnboardingLink
                              buttonTitle="Back Button"
                              buttonClass="btn-lg btn btn-outline-secondary"
                              buttonText="Cancel"
                              link={
                                props.history.location.pathname.includes(
                                  "admin"
                                )
                                  ? "/admin-edit-add-subscription"
                                  : "/subscription"
                              }
                            />
                            <ReusableOnboardingButton
                              buttonTitle="Next Button"
                              buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                              buttonText="Next"
                              buttonType="button"
                              //onClick={() => handleNextStep(2)}
                              onClick={(e) => onClickNext(e)}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {step === 2 && (
                      <React.Fragment>
                        <div className="nav-scroller mb-4">
                          <ul
                            className="enStepNav nav list-unstyled d-flex justify-content-between"
                            style={{ width: 300 }}
                          >
                            <li className="pho_24_medium done">
                              <div className="stepNumber">01</div>
                              <div className="text">Define Category</div>
                            </li>
                            <li className="doing">
                              <div className="stepNumber">02</div>
                              <div className="text">Taxes & Other Details</div>
                            </li>
                          </ul>
                        </div>
                        <Row>
                          <Col md={8}>
                            <NewInputText
                              labelText="Category Name"
                              extraClass="mb-3 w-100"
                              value={formik.values.name}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Form.Label className="f16-500 my-3">
                          Taxes & Other Charges
                        </Form.Label>
                        <Row className="align-items-center py-3">
                          <Col md={6}>
                            <div className="f14-700">Price Includes Taxes</div>
                            <div className="f11-400 opacity5">
                              (Taxes are same for all the items in the category)
                            </div>
                          </Col>
                          <Col md={6}>
                            <ToggleButtonWithYesNo
                              activeClass={WithTaxes}
                              checkedBox={WithTaxes}
                              onChange={handleWithTaxes}
                            />
                          </Col>
                        </Row>
                        <hr />
                        {WithTaxes === false ? (
                          <>
                            {taxInfo.map((item, index) => (
                              <Row
                                className="align-items-center py-3"
                                key={index}
                              >
                                <Col md={6}>
                                  <div className="f14-700">{item.tax_name}</div>
                                  <div className="f11-400 opacity5">
                                    {item.description}
                                  </div>
                                </Col>

                                <Col md={6}>
                                  <ToggleButtonWithYesNo
                                    activeClass={item.status}
                                    checkedBox={item.status}
                                    onChange={() =>
                                      handleChecked(item.status, index)
                                    }
                                  />
                                  {item.status ? (
                                    <div className="w-100">
                                      <div className="enFiledWith2Btn">
                                        <input
                                          type="text"
                                          value={item.value}
                                          placeholder="% or Value"
                                          className="f12-400"
                                          onChange={(e) =>
                                            handleUpdateValue(e, index)
                                          }
                                        />

                                        <div className="btnGroup">
                                          <button
                                            type="button"
                                            onClick={() =>
                                              handleTypeChange(item.flag, index)
                                            }
                                            className={`${
                                              item.flag === "PERCENTAGE"
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            %
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() =>
                                              handleTypeChange(item.flag, index)
                                            }
                                            className={`${
                                              item.flag === "VALUE"
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            ₹
                                          </button>
                                        </div>
                                      </div>
                                      {formikStepTwo.errors &&
                                      formikStepTwo.errors[index] &&
                                      formikStepTwo.errors[index].value ? (
                                        <div className="pho_14_regular text-danger">
                                          {formikStepTwo.errors[index].value}
                                        </div>
                                      ) : null}
                                    </div>
                                  ) : (
                                    <> </>
                                  )}
                                </Col>
                              </Row>
                            ))}

                            <div className="mb-4">
                              <AddButtonIconComponent
                                buttonText="Add Another Surcharge"
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                                buttonType="button"
                                onClick={(e) => addCustomSurcharge(e)}
                              />
                            </div>
                            {customSurcharge.map((charge, index) => (
                              <Row key={index}>
                                <Col md={8}>
                                  <NewInputText
                                    labelText="Surcharge Name"
                                    controlClass={"tax_name"}
                                    extraClass={`mb-1 w-100 ${
                                      formikCustom.errors.tax_name &&
                                      formikCustom.touched.tax_name
                                        ? "enError"
                                        : ""
                                    }`}
                                    name="tax_name"
                                    onChange={formikCustom.handleChange}
                                    value={formikCustom.values.tax_name}
                                    onFocusOut={formikCustom.handleBlur}
                                  />
                                  {formikCustom.errors.tax_name &&
                                  formikCustom.touched.tax_name ? (
                                    <div className="pho_14_regular text-danger">
                                      {formikCustom.errors.tax_name}
                                    </div>
                                  ) : null}
                                </Col>
                                <Col md={2} className="pt-2">
                                  <AddButtonIconComponent
                                    buttonText="Add"
                                    buttonType="button"
                                    onClick={formikCustom.handleSubmit}
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                </Col>

                                <Col md={2} className="pt-2">
                                  <AddButtonIconComponent
                                    buttonText="Delete"
                                    // onClick={onOthersDeleteHandler(index)}
                                    onClick={(e) => deleteCustomSurcharge(e)}
                                    fontIcon="fa fa-trash-o"
                                    colorCss="delete"
                                  />
                                </Col>
                                <Col md={8}>
                                  <Row>
                                    <Col md={6}>
                                      <div className="enFiledWith2Btn m-0">
                                        <input
                                          type="number"
                                          placeholder="% or Value"
                                          className={`f12-400" ${
                                            formikCustom.errors.value &&
                                            formikCustom.touched.value
                                              ? "enError"
                                              : ""
                                          }`}
                                          name="value"
                                          onChange={formikCustom.handleChange}
                                          value={formikCustom.values.value}
                                          onFocusOut={formikCustom.handleBlur}
                                        />

                                        <div className="btnGroup">
                                          <button
                                            type="button"
                                            onClick={() =>
                                              handleTextPORV("PERCENTAGE")
                                            }
                                            className={`${
                                              active === "PERCENTAGE"
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            %
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() =>
                                              handleTextPORV("VALUE")
                                            }
                                            className={`${
                                              active === "VALUE" ? "active" : ""
                                            }`}
                                          >
                                            ₹
                                          </button>
                                        </div>
                                      </div>
                                      {formikCustom.errors.value &&
                                      formikCustom.touched.value ? (
                                        <div className="pho_14_regular text-danger">
                                          {formikCustom.errors.value}
                                        </div>
                                      ) : null}
                                    </Col>
                                    <Col md={6}>
                                      <NewInputText
                                        labelText="Description"
                                        extraClass="mb-3 w-100"
                                        multiline={true}
                                        rows="4"
                                        name="description"
                                        onChange={formikCustom.handleChange}
                                        value={formikCustom.values.description}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            ))}
                          </>
                        ) : (
                          <> </>
                        )}
                        <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                          <div>
                            <ReusableOnboardingButton
                              buttonTitle="Back Button"
                              buttonClass="btn-lg btn btn-outline-secondary"
                              buttonText="Back"
                              onClick={() => handleNextStep(1)}
                            />
                            <ReusableOnboardingButton
                              buttonTitle="Next Button"
                              buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                              buttonText="Save"
                              buttonType="button"
                              onClick={(e) => onClickSave(e)}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </Form>
                </div>
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  // displayBarButton={false}
                  displayHamburger={true}
                  headingText={"Menu Set Up - Categories"}
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </>
  );
};

FastFoodAddCategories.propTypes = {
  auth: PropTypes.object.isRequired,
  add_category_menu_setup: PropTypes.func.isRequired,
  edit_category_menu_setup: PropTypes.func.isRequired,
  update_ordering_subscription_taxes: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  auth: state.auth,
  errors: state.errors.errors,
  activeCategoryData: ownProps?.location?.pathname?.includes("admin")
    ? state.superAdminOnboarding.activeCategoryData
    : state.onboarding.activeCategoryData,

  orderingTaxesData: ownProps?.location?.pathname?.includes("admin")
    ? state?.superAdminOnboarding?.onboard_subscription_details
        ?.casual_dining_status?.ordering?.order_general
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.ordering?.order_general
    : state?.onboarding?.onboard_subscription_details?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.ordering?.order_general
    : state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.ordering?.order_general,
});

export default connect(mapStateToProps, {
  add_category_menu_setup,
  edit_category_menu_setup,
  update_ordering_subscription_taxes,
})(FastFoodAddCategories);
